// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import styled from '@emotion/styled';

import type { CommonActionProps } from './types.actions';
import type { GridItem } from '../../types';
import ToggleController from '../../controllers/ToggleController';
import Row from '../Row';
import Col from '../Col';
import ButtonAction from './ButtonAction';
import FormRow from '../FormRow';
import DescriptionField from '../DescriptionField';
import SingleField from '../SingleField';
import { DesktopView, MobileView, useMobileMediaQuery } from '../../config/mediaQuery';

type Props = {
  item: GridItem,
};

const Spacer = styled('div')`
  width: 20px;
`;

const ShowAdditional = (props: { item: GridItem }) => {
  const isMobile = useMobileMediaQuery();
  const { item } = props;

  if (!item) return null;

  return (
    <div>
      {!isMobile &&
        <FormRow>
          <ControlLabel>
            {item.AcctNo} {item.AcctName}
          </ControlLabel>
        </FormRow>
      }
      <DescriptionField readOnly label="Address" value={item.Address} />
      <DescriptionField readOnly label="Delivery Notes" value={item.DelNote} />
      <DesktopView>
        <Row>
          <Col
            css={{
              flex: 1,
            }}
          >
            <SingleField readOnly label="Account Type" value={item.Type} />
            <SingleField readOnly label="Wine Focus" value={item.Focus} />
            <SingleField readOnly label="Growth Potential" value={item.Growth} />
            <SingleField readOnly label="Key Suppliers" value={item.Sup} />
            <SingleField readOnly label="Balance" value={item.Bal} />
            <SingleField readOnly label="Past Due" value={item.Due} />
            <SingleField readOnly label="PO# Required" value={item.Po} />
          </Col>
          <Spacer />
          <Col
            css={{
              flex: 1,
            }}
          >
            <SingleField label="Wine Buyer 2" value={item.Wb2} />
            <SingleField label="Wine Buyer 2 Phone" value={item.Wb2Phone} />
            <SingleField label="Wine Buyer 2 Email" value={item.Wb2Email} />
            <SingleField label="Wine Buyer 3" value={item.Wb3} />
            <SingleField label="Wine Buyer 3 Phone" value={item.Wb3Phone} />
            <SingleField label="Wine Buyer 3 Email" value={item.Wb3Email} />
            <SingleField label="License" value={item.Lic} />
          </Col>
        </Row>
      </DesktopView>
      <MobileView>
        <SingleField readOnly label="Account Type" value={item.Type} />
        <Row>
          <Col
            css={{
              flex: 1,
            }}
          >
            <SingleField readOnly label="Wine Focus" value={item.Focus} />
            <SingleField readOnly label="Key Suppliers" value={item.Sup} />
            <SingleField readOnly label="Past Due" value={item.Due} />

          </Col>
          <Spacer />
          <Col
            css={{
              flex: 1,
            }}
          >
            <SingleField readOnly label="Growth Potential" value={item.Growth} />
            <SingleField readOnly label="Balance" value={item.Bal} />
            <SingleField readOnly label="PO# Required" value={item.Po} />
          </Col>
        </Row>
        <SingleField label="Wine Buyer 2" value={item.Wb2} />
        <SingleField label="Wine Buyer 2 Phone" value={item.Wb2Phone} />
        <SingleField label="Wine Buyer 2 Email" value={item.Wb2Email} />
        <SingleField label="Wine Buyer 3" value={item.Wb3} />
        <SingleField label="Wine Buyer 3 Phone" value={item.Wb3Phone} />
        <SingleField label="Wine Buyer 3 Email" value={item.Wb3Email} />
        <SingleField label="License" value={item.Lic} />
      </MobileView>
    </div>
  );
};

const AdditionalInfoAction = (props: CommonActionProps & Props) => (
  <ToggleController>
    {({ onToggleVisibility, visible }) => (
      <React.Fragment>
        <DesktopView>
          <ButtonAction
            bsSize={props.size}
            disabled={props.disabled}
            onClick={onToggleVisibility}
          >
            <Glyphicon glyph="info-sign" /> Additional Info
          </ButtonAction>
        </DesktopView>
        <MobileView>
          <button onClick={onToggleVisibility} disabled={props.disabled}>
            <img src='assets/info.svg' alt='info icon'/> Additional Info
          </button>
        </MobileView>
        <MobileView>
          {(isMobile) => (
            <Modal show={visible} onHide={onToggleVisibility} dialogClassName={isMobile ? 'additional-info-modal': ''}>
              <Modal.Header closeButton={!isMobile}>
                <Modal.Title>Info</Modal.Title>
                {isMobile && props.item && <p>{props.item.AcctNo} {props.item.AcctName}</p>}
              </Modal.Header>
              <Modal.Body>
                <ShowAdditional item={props.item} />
              </Modal.Body>
              <Modal.Footer>
                <DesktopView>
                  <Button onClick={onToggleVisibility}>Close</Button>
                </DesktopView>
                <MobileView>
                  <div className='button-single-modal'>
                    <button
                      onClick={onToggleVisibility}
                    >
                      Close
                    </button>
                  </div>
                </MobileView>
              </Modal.Footer>
            </Modal>
          )}

        </MobileView>
      </React.Fragment>
    )}
  </ToggleController>
);

AdditionalInfoAction.defaultProps = {
  size: 'xsmall',
};

export default AdditionalInfoAction;
